/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import React from 'react'
import { Section, getState, fmt, parseHtml, showModal} from '../twd'
import { useBondDetail } from './use-bond-detail'
import { sectionCss, sectionListCss, } from './style'
import Underwriter from './underwriter'

const state = getState('bond_detail.original_issuance', {
    show: true
})

export default () => {
    const [showSection, setShowSection_] = React.useState(state.value.show)
    const setShowSection = React.useCallback((m) => {
        state.set({show:m})
        setShowSection_(m)
    }, [])

    const { issue } = useBondDetail()
    let invType = issue.type
    let hasMore = ['C','M','T','A','S'].indexOf(invType) >= 0
        && !(invType==='C' && issue.category==='N')
        && !(invType==='S' && issue.category==='N')
    let isPreferred = invType==='P'
    return <React.Fragment>
    <div className="xs-hide vertical-offset-sm"></div>
    <div data-name='bond-detail-original-issuance'
        className="container vertical-offset-sm"
        css={sectionCss}>

        <div className="row vertical-offset-sm"></div>
        <div className="row"><div className="col-xs-12">
            <Section
                title="Original issuance"
                show={showSection}
                setShow={setShowSection}
                cls="small-header"
                arrowSize="large"
            >
            <dl css={sectionListCss}>
                <dt>Issue Date</dt>
                <dd>{fmt.mdy(issue.issueDt)}</dd>

                <dt>Dated date</dt>
                <dd>{fmt.mdy(issue.dated) || fmt.empty()}</dd>

                <dt>First trade date</dt>
                <dd>{parseHtml(issue.firstExecution) || fmt.empty()}</dd>

                <dt>First settlement</dt>
                <dd>{fmt.mdy(issue.firstSettlement) || fmt.empty()}</dd>

                <dt>Original size</dt>
                <dd>{fmt.qty(
                        parseHtml(issue.originalIssue).trim().replaceAll('$','').replaceAll(',',''),
                        isPreferred ? {} : {style:'currency', currency:'USD', maximumFractionDigits:0},
                        isPreferred ? ' Shares' : '',
                    )
                }</dd>

                <dt>Outstanding issue size</dt>
                <dd>{fmt.qty(
                    issue.outstandingAmt,
                    {style:'currency', currency:'USD', maximumFractionDigits:0},
                )}</dd>

                <dt>Original issue price/yield</dt>
                <dd>{fmt.price3(issue.originalPrice)}/{fmt.ytw(issue.originalYield)}</dd>

                <dt>Revised issue price</dt>
                <dd>{fmt.priceDemin(issue.revIssuePrice)}</dd>

                <dt>Delivery</dt>
                <dd>{DELIVERY[issue.delivery] || fmt.empty()}</dd>

                <dt>Underwriter</dt>
                <dd><Underwriter html={issue.underwriter} /></dd>

                <dt>Collateral</dt>
                <dd>{parseHtml(issue.collateralDesc) || fmt.empty()}</dd>

                <dt>Factor</dt>
                <dd>{
                    (issue.factor && Array.from(issue.factorList).length>0 && <button
                        className="link-button"
                        onClick={(e) => {
                            showModal({
                                view: 'factors',
                                list: issue.factorList,
                                from: 'bond-detail',
                                source: e.target,
                            })
                        }}>
                    {fmt.factor(issue.factor)}
                    </button>)
                    || (issue.factor && <React.Fragment>{fmt.factor(issue.factor)}</React.Fragment>)
                    || fmt.empty()
                }</dd>
            </dl>

            {hasMore && <div className="row"><div className="col-xs-12">
                <button
                    className="link-button"
                    onClick={(e) => {
                        showModal({
                            view: 'offerings-modal',
                            name: (issue.issueDisplay),
                            maturity: 'ALL',
                            params: {
                                persistToPreviousSearches: false,
                                holdInvType: [issue.type],
                                ...(issue.type==='C' && issue.symbol && {holdSymbol:[issue.symbol]}),
                                ...(issue.type!=='C' && {holdIssue:[issue.issue]}),
                            },
                            from: 'bond-detail',
                            source: e.target,
                        })
                    }}>
                More offerings from this issuer
                </button>
            </div></div>}

            </Section>
        </div></div>

        <div className="row vertical-offset-sm"></div>


    </div>

    </React.Fragment>
}


let DELIVERY = {
    "A": "Registered Or Bearer",
    "B": "Bearer",
    "C": "Book Entry",
    "I": "Interchangeable",
    "R": "Registered",
    "Z": "Custodial Receipt"
}